import { createContext } from 'react';
export default createContext({
  linkColorPrimary: '#2a1b43',
  // client color 1
  linkColorSecondary: '#c6b4e3',
  // client color 2
  trimColorPrimary: '#2a1b43',
  // client color 3
  trimColorSecondary: '#61279e' // client color 4
});